<script setup lang="ts">
const { id } = useRoute().params

const url = `/api/timelines/tag/${id}/profiles`
const channel = `timeline:tag:${id}:profiles`
</script>

<template>
  <TimelineActors :url="url" :channel="channel" />
</template>
